import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import ReelsPlayer from '../components/ReelsPlayer';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const VODReelView = () => {
  const { reelId } = useParams();
  const navigate = useNavigate();
  const [reel, setReel] = useState(null);
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchReel();
  }, [reelId]);

  const fetchReel = async () => {
    try {
      // Fetch the specific reel
      const reelResponse = await axios.get(`${API}/api/reels/${reelId}`);
      setReel(reelResponse.data);

      // Fetch more reels for the player
      const reelsResponse = await axios.get(`${API}/api/reels?limit=20`);
      const allReels = reelsResponse.data.reels || [];
      
      // Put the current reel first
      const orderedReels = [
        reelResponse.data,
        ...allReels.filter(r => r.id !== reelId)
      ];
      setReels(orderedReels);
      
    } catch (err) {
      console.error('Error fetching reel:', err);
      setError('Reel not found');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate('/vod');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-pink-500" />
      </div>
    );
  }

  if (error || !reel) {
    return (
      <div className="min-h-screen bg-black flex flex-col items-center justify-center text-white">
        <h1 className="text-2xl font-bold mb-4">Reel Not Found</h1>
        <p className="text-gray-400 mb-6">This reel may have been removed or is unavailable.</p>
        <button 
          onClick={() => navigate('/vod')}
          className="px-6 py-2 bg-pink-600 rounded-full hover:bg-pink-500 transition"
        >
          Browse More Content
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{reel.title} | LTV VOD</title>
        <meta name="description" content={reel.description || `Watch ${reel.title} on LTV VOD`} />
        <meta property="og:title" content={`${reel.title} | LTV VOD`} />
        <meta property="og:description" content={reel.description || `Watch ${reel.title} on LTV VOD`} />
        <meta property="og:type" content="video.other" />
        <meta property="og:url" content={`${window.location.origin}/vod/reel/${reelId}`} />
        {reel.thumbnail_url && <meta property="og:image" content={reel.thumbnail_url} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${reel.title} | LTV VOD`} />
        <meta name="twitter:description" content={reel.description || `Watch ${reel.title} on LTV VOD`} />
        {reel.thumbnail_url && <meta name="twitter:image" content={reel.thumbnail_url} />}
      </Helmet>

      <ReelsPlayer
        isOpen={true}
        onClose={handleClose}
        initialReelId={reelId}
        reels={reels}
      />
    </>
  );
};

export default VODReelView;
